// extracted by mini-css-extract-plugin
export default {"root":"root-LwJLu","top":"top-OSrBj","bottom":"bottom-fQsec","left":"left-mFoC-","right":"right-5yDSx"};